import { useEffect, useState } from 'react';

import { TAuth, IOktaIdToken, IOktaAccessToken } from '../interfaces';

type TUseDetectSessionAndAutoLogin = {
  auth: TAuth;
  redirectUrl: string;
  saveOktaIdToken: (idToken: IOktaIdToken, auth: TAuth) => void;
  saveOktaAccessToken: (accessToken: IOktaAccessToken, auth: TAuth) => void;
};

export function useDetectSessionAndAutoLogin({
  auth,
  redirectUrl,
  saveOktaIdToken,
  saveOktaAccessToken,
}: TUseDetectSessionAndAutoLogin) {
  const [isCheckingSession, setIsCheckingSession] = useState(true);
  const [hasCheckedSession, setHasCheckedSession] = useState(false);
  useEffect(
    function detectSessionAndLogin() {
      if (isCheckingSession && !hasCheckedSession) {
        setHasCheckedSession(true);
        const oktaAuth = auth._oktaAuth;
        oktaAuth.session
          .get()
          .then((res) => {
            if (res.status === 'ACTIVE') {
              oktaAuth.token
                .getWithoutPrompt({
                  responseType: ['id_token', 'token'],
                })
                .then(({ tokens: { accessToken, idToken } }) => {
                  Promise.all([
                    saveOktaAccessToken(accessToken, auth),
                    saveOktaIdToken(idToken, auth),
                  ]).then(() => {
                    if (redirectUrl) {
                      window.location.href = redirectUrl;
                    } else {
                      setIsCheckingSession(false);
                    }
                  });
                })
                .catch(() => {
                  setIsCheckingSession(false);
                });
            } else {
              setIsCheckingSession(false);
            }
          })
          .catch(() => {
            setIsCheckingSession(false);
          });
      }
    },
    [
      auth,
      auth._oktaAuth,
      isCheckingSession,
      redirectUrl,
      saveOktaAccessToken,
      saveOktaIdToken,
    ]
  );

  return {
    isCheckingSession,
  };
}
